import utils from 'utils';
class cashFlowStatementListPageCtrl {
  constructor(
    $scope,
    httpRequest,
    $state,
    $stateParams,
    sweetalert,
    logger,
    tableQueryConfig,
    $timeout,
    authService,
    $filter,
    Upload,
    $uibModal
  ) {
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    $scope.active = 3;
    // 查询字段设置
    $scope.customizedConfig = tableQueryConfig[2];
    $scope.$on('statementType', (event, date) => {
      $scope.queryParam.param.applyPeriod = date;
      queryInfo();
    });
    // $scope.$emit('reset');
    $scope.importBtnCollapsed = false;
    // 查询的参数
    $scope.queryParam = {
      pageSize: 10,
      pageNum: 1,
      param: {
        applyPeriod: utils.getQuarter(),
      },
    };
    // 重置
    $scope.reset = function () {
      $scope.belleRegionCityList = [];
      $scope.queryParam.param = {
        applyPeriod: utils.getQuarter(),
      };
      $scope.$emit('reset');
    //   queryInfo();
    getUserInfo()
    };
    // 勾选的信息
    $scope.selectedRows = [];
    //自动查询展示
    const queryInfo = function queryInfo() {
      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;
      httpRequest
        .post_getSmallCashList(queryDataHandle($scope.queryParam))
        .then((res) => {
          $scope.listData = res.data.value.list;
          $scope.totalItems = res.data.value.total;
          $scope.queryParam.pageNum = res.data.value.pageNum;
          $scope.queryParam.pageSize = res.data.value.pageSize;
          $scope.selectedRows = [];
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
    };
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }
    // 搜索
    $scope.searchList = function () {
      queryInfo();
    };
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo();
    };
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo();
    };
    // 字典
    const typecodeArrStr = [
      'zzs_data', // 数据来源
      'department_no',
      'status', //启用 禁用
      'glsale_declaration', //申报状态
      'cwbb_dataSources',
      'submission_status',
      'zzs_status',
    ];
    $scope.dictionary = {};
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      $scope.dictData = $.extend($scope.dictionary, res.data.value);
    });
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 获取所有主管税局信息
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 联动查询管理城市
    $scope.linkageQuery = function (enumName) {
      let departmenNoObj = $scope.dictData.department_no.find((v) => {
        return v.enumName === enumName;
      });
      let belleRegionListObj = $scope.belleRegionList.find((v) => {
        return v.regionName === enumName;
      });
      if (departmenNoObj) {
        $scope.departmentNo = departmenNoObj.enumCode;
      }
      if (belleRegionListObj) {
        $scope.regionNo = belleRegionListObj.treeLevelCode;
      }
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    };
    // queryInfo();
    $scope.queryInfo = queryInfo;
    $scope.tableDropdownConfig = [
      {
        label: '删除',
        handler(item) {
          $scope.batchDeletion([item]);
        },
        showWhile(item, hasPermit) {
          //   return hasPermit('single_deletion');
          return true;
        },
      },
    ];
    // 导入
    $scope.uploadFiles = function uploadFiles(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError(
          '文件类型错误，文件大小不超过20MB，只支持.xlsx,.xls格式文件导入'
        );
        return;
      }
      if (file) {
        file.upload = Upload.upload({
          url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importSales`,
          data: {
            importFile: file,
            code: 'SB_SMALLCASH',
            applyPeriod: $scope.queryParam.param.applyPeriod,
          },
        });
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        });
        file.upload.then(
          (res) => {
            $timeout(() => {
              if (!res.data.success) {
                layer.close(importinglayer);
                return logger.logError(res.data.message || '上传失败');
              }
              if (res.data.value.sourceCount === 0) {
                layer.close(importinglayer);
                return logger.logTips('导入数据为空！', 'warn');
              }
              const { batchNo, sourceCount, errorCount } = res.data.value;
              // 结果弹框
              // if (res.data.value.errorCount > 0) {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: 1,
                  pageSize: 10,
                  param: res.data.value.batchNo,
                })
                .then((res1) => {
                  layer.close(importinglayer);
                  $scope.importResultModal({
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: res1.data.value,
                  });
                  $scope.queryInfo();
                });
            });
          },
          (response) => {}
        );
      }
    };
    // 导入结果弹窗
    $scope.importResultModal = function (modalData) {
      const modalInstance = $uibModal.open({
        templateUrl: 'importResult.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.modalData = items1;
            $scope.list = items1.data.list;
            console.log($scope.modalData);
            $scope.pageOptions = {
              // 分页器
              totalItems: $scope.modalData.data.total,
              currentPage: ++$scope.modalData.data.prePage,
              maxSize: $scope.modalData.data.pageSize,
            };
            // 关闭
            $scope.ok = () => {
              $uibModalInstance.close();
            };
            // 分页查询
            $scope.pageChanged = () => {
              queryList();
            };
            function queryList() {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: $scope.pageOptions.currentPage,
                  pageSize: $scope.pageOptions.maxSize,
                  param: $scope.modalData.batchNo,
                })
                .then((res) => {
                  $scope.list = res.data.value.list;
                  $scope.pageOptions = {
                    // 分页器
                    totalItems: res.data.value.total,
                    currentPage: ++res.data.value.prePage,
                    maxSize: res.data.value.pageSize,
                  };
                });
            }
            // 导出错误详情
            $scope.downBatchInfo = function () {
              window.open(
                `${host.etcloudIvatApp}dl/dlTaskService/downBatchInfoDetail?batchNo=${$scope.modalData.batchNo}&accessToken=${localStorage.id_token}`
              );
            };
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal-importexcel',
        windowClass: 'mod-modal mod-modal-lg',
        bindToController: true,
        resolve: {
          items1() {
            return modalData;
          },
        },
      });
      modalInstance.result.then(
        () => {},
        () => {}
      );
    };
    // 模板下载
    $scope.downloadExcel = function () {
      window.open(
        `${
          host.etcloudIvatApp
        }dl/dlTaskService/export_SB_SMALLCASH?accessToken=${localStorage.getItem(
          'id_token'
        )}`
      );
    };
    // 批量删除 单个
    $scope.batchDeletion = function (singleList) {
      let selectedRows = singleList ? singleList : $scope.selectedRows;
      if (!selectedRows.length) {
        return logger.logError('请选中纳税人后操作');
      }
      let selectedTaxNoList = [];
      selectedRows.forEach((item, index) => {
        selectedTaxNoList.push(item.taxNo);
      });
      let params = {
        applyPeriod: $scope.queryParam.param.applyPeriod,
        taxNo: selectedTaxNoList,
        type: 'SB_SMALLCASH',
      };
      $scope.comfirmDeletion(params);
    };
    $scope.comfirmDeletion = function (params) {
      httpRequest
        .post_getSmallAssetsListDelete(params, '删除成功')
        .then((res) => {
          queryInfo();
          // 重置
          $scope.selectedRows = [];
        });
    };
    //导出
    $scope.exportExel = function exportExel() {
      let fileName =
        '现金流量表_小企业准则_' + $scope.queryParam.param.applyPeriod;
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
        'id_token'
      )}`;
      utils.file_download(
        url,
        $scope.queryParam.param,
        'SB_SMALLCASH', //type
        'POST',
        'blob',
        fileName,
        false
      );
    };
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
cashFlowStatementListPageCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  '$stateParams',
  'sweetalert',
  'logger',
  'tableQueryConfig',
  '$timeout',
  'authService',
  '$filter',
  'Upload',
  '$uibModal',
];
export default cashFlowStatementListPageCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/smallBusinessGuidelines/cashFlowStatementListPageCtrl.js